// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3jbD5","col":"CardReaderDesc_col__3G-qN","label":"CardReaderDesc_label__1jRe5"};